import styles from './Confirm.module.scss';

/**
 * Confirm 컴포넌트
 * - 공용 확인창 컴포넌트 (예/아니오 선택)
 * - 화면 정중앙에 표시
 * - Alert 컴포넌트(예/아니오 모드)와 동일한 둥근 형태 스타일 적용
 *
 * @param {boolean} isOpen - 확인창 표시 여부
 * @param {string} message - 확인 메시지
 * @param {Function} onConfirm - 확인(예) 클릭 핸들러
 * @param {Function} onCancel - 취소(아니오) 클릭 핸들러
 * @param {string} confirmText - 확인 버튼 텍스트 (기본값: '예')
 * @param {string} cancelText - 취소 버튼 텍스트 (기본값: '아니오')
 * @param {string} className - 추가 CSS 클래스
 */
function Confirm({
  isOpen,
  message,
  onConfirm,
  onCancel,
  confirmText = '예',
  cancelText = '아니오',
  className = '',
}) {
  if (!isOpen) {
    return null;
  }

  /**
   * 오버레이(배경) 클릭 핸들러
   * - 오버레이 영역을 클릭하면 확인창을 닫음 (취소 동작)
   */
  function handleOverlayClick(e) {
    if (e.target === e.currentTarget) {
      onCancel();
    }
  }

  return (
    <div className={styles.overlay} onClick={handleOverlayClick}>
      <div
        className={`${styles.confirmContainer} ${className}`}
        onClick={function (e) {
          e.stopPropagation();
        }}
      >
        <div className={styles.message}>{message}</div>
        <div className={styles.buttonContainer}>
          <button type="button" className={styles.cancelButton} onClick={onCancel}>
            {cancelText}
          </button>
          <button type="button" className={styles.confirmButton} onClick={onConfirm}>
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}

export default Confirm;
